import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { EmploymentStatDTO } from './dto/employment-status.dto';
import { AllEmploymentStatusResponse, EmploymentStatusResponse } from '@gtpl/shared-models/hrms';
import { EmploymentStatRequest } from './dto/employment-status.request';
import { EmploymentStatusService } from './employment-status.service';

@ApiTags('employment-status')
@Controller('employment-status')
export class EmploymentStatusController {
    constructor(
        private service: EmploymentStatusService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createEmployStatus')
    async createEmployStatus(@Body() DTO: EmploymentStatDTO, isUpdate: boolean = false): Promise<EmploymentStatusResponse>{
        try{
            return await this.service.createEmploymentStatus(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmploymentStatusResponse, error);
        }
    }

    @Post('/updateEmployStatus')
    async updateEmployStatus(@Body() DTO: EmploymentStatDTO, isUpdate: boolean = false): Promise<EmploymentStatusResponse>{
        try{
            return await this.service.createEmploymentStatus(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmploymentStatusResponse, error);
        } 
    }

    @Post('/getAllEmployStats')
    async getAllEmployStats(): Promise<AllEmploymentStatusResponse>{
        try{
            return await this.service.getAllEmploymentStats();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllEmploymentStatusResponse, error);
        }
    }

    @Post('/getAllActiveEmployStats')
    async getAllActiveEmployStats(): Promise<AllEmploymentStatusResponse>{
        try{
            return await this.service.getAllActiveEmployStats();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllEmploymentStatusResponse, error);
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() req: EmploymentStatRequest): Promise<EmploymentStatusResponse>{
        try{
            return await this.service.activateOrDeactivateEmployStatus(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmploymentStatusResponse, error)
        }
    }
}
